module.exports = __webpack_public_path__ + "static/media/1-1.60bc21ea.png";